import { Field } from 'formik'
import { FC, useState } from 'react'
import 'react-quill/dist/quill.snow.css'
import ErrorMessage from '../ErrorMessage'
import { StyleFormWrapper, StyleLabel } from '../style'
import { StyleReactQuill } from './style'
interface EditorProps {
  name: string
  onChange?: (value: any) => void
  label?: string
  styleWrapper?: string
  styleLabel?: string
}
const Editor: FC<EditorProps> = ({
  name,
  label,
  onChange,
  styleLabel,
  styleWrapper,
}) => {
  const [focus, setFocus] = useState<boolean>(false)

  const handleChange = ({ form, value }: any) => {
    onChange && onChange(value)
    form.setFieldValue(name, value)
  }
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper hasError={hasError} styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleReactQuill
              theme="snow"
              isFocus={focus}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              value={field?.value || ''}
              onChange={(value: string) => {
                handleChange({
                  form,
                  value,
                })
              }}
            />
            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Editor
